import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AlertType, IAlertState } from './alerts.slice.types'

const initialState: IAlertState = {
  alerts: [],
}

export const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    addAlert: (state, action: PayloadAction<{ alert: AlertType }>) => {
      state.alerts = [...state.alerts, action.payload.alert]
    },
    deleteAlert: (state, action: PayloadAction<{ index: number }>) => {
      state.alerts = state.alerts.filter((_, index) => index !== action.payload.index)
    },
  },
})

export const AlertsActions = alertsSlice.actions
export const alertsReducer = alertsSlice.reducer
